<section (click)="onTriageFormClick($event)">
  <h2>Triage/Review Crime Gun</h2>
  <p-messages key="cgTriageMsg" [closable]="true"></p-messages>
  <div *ngIf="canEditTriage()" class="card mb-3">
    <div class="card-body">
      <form [formGroup]="triageFormGroup" (ngSubmit)="onSubmitTriage()">
        <fieldset class="mb-3">
          <legend class="required-field fs-4 fw-semibold mb-2">Triage level:</legend>
          <div class="form-check" *ngFor="let triageRb of triageTierLevels$ | async;let i = index">
            <input class="form-check-input" formControlName="TriageTierLevelID" id="Tier{{i}}" type="radio" value="{{triageRb.TriageTierLevelID}}" *ngIf="triageRb.TriageLevelName.includes('Tier')" />
            <label for="Tier{{i}}" class="form-check-label" *ngIf="triageRb.TriageLevelName.includes('Tier')">{{ triageRb.TriageLevelName}}: {{ triageRb.TriageLevelDescription}}</label>
          </div>
          <div class="cross-validation-feedback" style="margin-left: 1.5rem;" *ngIf="triageFormGroup.get('TriageTierLevelID').invalid">
            Please select the triage level.
          </div>
        </fieldset>
        <div>
          <label for="Comment" class="form-label">Comment: (max 1000 characters)</label>
          <textarea id="Comment" formControlName="Comment" class="form-control" rows="{{defaultTextAreaRows}}"></textarea>
          <div class="invalid-feedback">Comment must be 1000 characters or less.</div>
        </div>
        <button type="submit" class="btn btn-active my-3" [disabled]="triageFormGroup.invalid">Submit</button>
        <button type="button" class="btn btn-secondary" (click)="onResetTriage()">Reset</button>
      </form>
    </div>
  </div>
</section>
